import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import Balearic from './locales/ba_ES.json'
import Catalan from './locales/ca_ES.json'
import English from './locales/en_GB.json'
import Spanish from './locales/es_ES.json'
import SpanishMexican from './locales/es_MX.json'
import French from './locales/fr_FR.json'
import Galician from './locales/gl_ES.json'
import Valencian from './locales/va_ES.json'
import German from './locales/de_DE.json'
// import Basque from './locales/eu_ES.json'
import Italian from './locales/it_IT.json'
import Polish from './locales/pl_PL.json'
import Ar from './locales/es_AR.json'
import Latam from './locales/es_419.json'
import Slovenian from './locales/sl_SI.json'

export const unicodeToIsoMap = {
  'ca-ES': 'ca',
  'ca-ES-balear': 'ba',
  'ca-ES-valencia': 'va',
  'de-DE': 'de',
  'en-GB': 'en',
  'es-419': 'latam',
  'es-AR': 'ar',
  'es-ES': 'es',
  'es-MX': 'mx',
  'eu-ES': 'eu',
  'fr-FR': 'fr',
  'gl-ES': 'gl',
  'it-IT': 'it',
  'pl-PL': 'pl',
  'sl-SI': 'sl',
}

export const defaultLocale = 'es'

i18n.use(LanguageDetector).init({
  // have a common namespace used around the full app
  defaultNS: 'translations',

  fallbackLng: defaultLocale,

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
  },

  keySeparator: '.', // we use content as keys

  ns: ['translations'],
  nsSeparator: false, // we use content as keys

  react: {
    wait: false,
  },

  // we init with resources
  resources: {
    ar: {
      translations: Ar,
    },
    ba: {
      translations: Balearic,
    },
    ca: {
      translations: Catalan,
    },
    de: {
      translations: German,
    },
    en: {
      translations: English,
    },
    es: {
      translations: Spanish,
    },
    eu: {
      translations: Spanish, // Todo: Basque
    },
    fr: {
      translations: French,
    },
    gl: {
      translations: Galician,
    },
    it: {
      translations: Italian,
    },
    latam: {
      translations: Latam,
    },
    mx: {
      translations: SpanishMexican,
    },
    pl: {
      translations: Polish,
    },
    sl: {
      translations: Slovenian,
    },
    va: {
      translations: Valencian,
    },
  },
})

export default i18n
